module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Execute_Black.b5e5e4ee.svg";